import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CardImg, Button, CardTitle } from 'reactstrap';
import { Container } from 'reactstrap';
import { Row, Col } from "antd";
import {
  Widget,
  addResponseMessage,
  renderCustomComponent,
  toggleWidget,
  dropMessages,
  addLinkSnippet
} from 'react-chat-widget';

import './styles.css';
import './index.style.css'
import 'axios';
import Axios from 'axios';

import QuickReply from './quickreply';
import logo from '../../assets/chat/smile1.png';
import sandee_ok from '../../assets/chat/sandee_ok.png';
import teamwork_samard from '../../assets/feednews/teamwork_samard.png';
import AIChatbox from "./AIChatbox"
import SAPChangeOwnerChatbox from './SAPChangeOwnerChatbox';
import guide_book from "../../assets/feednews/guide_book.png";
import sandee_ai from "../../assets/chat/sandee_ai.png"
import laptop from "../../assets/chat/laptop.png"
import sap from "../../assets/chat/sap.png"
import help from "../../assets/chat/get_help.png"
import service from "../../assets/chat/servicelevelone.png"
import sap_Ariba from "../../assets/chat/SAP-Ariba-logo-vierkant.png"
import { validateADPassword } from './ADPasswordPolicy';

// var self;
var session = '';
var action = '';
var json;
var json_csharp;
var message = '';
var listenv = [];
var blockingState = false;
var lastMessage = false;
var clickEventExist = false;
var lambda_api = '';
var csharp_api = '';
var showflag = true;
var v_typeofservice = '';
var closesender = false;
var pasteEventNum = 0;
var clearCloseTyping = false;
class changeMode extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div style={{ color: '#ccc' }}>
        <h6>Start Session {this.props.mode}</h6>
      </div>
    );
  }
}
export default class Chat extends Component {
  constructor(props) {
    super(props);
    // self = this;
    this.state = {
      sateshowflag: false,  /*If sateshowflag: = ture It will show widget (For feature if scan QR code it will automatic show gethelp widget )*/
      // clicked_th: false,
      // clicked_eng: false
      toggleAI: false,
      toggleSAPChangeOwner: false,
      verifyADPass: false,
      preventPaste: false
    };
    this.menuADClick = this.menuADClick.bind(this);
    this.menuEHRClick = this.menuEHRClick.bind(this);
    this.menuSAPClick = this.menuSAPClick.bind(this);
    this.menuS47Click = this.menuS47Click.bind(this);
    this.menuSCGPClick = this.menuSCGPClick.bind(this);
    this.menuGenAIClick = this.menuGenAIClick.bind(this);
    this.menuSAPChangeOwnerClick = this.menuSAPChangeOwnerClick.bind(this);
    // this.menuGenAIClickTH = this.menuGenAIClickTH.bind(this);
    this.menuSCGARIBAClick = this.menuSCGARIBAClick.bind(this);
    this.handleNewUserMessage = this.handleNewUserMessage.bind(this);
    // this.menuEHRClick();
  }

  /* For feature if scan QR code it will automatic show gethelp widget */
  // componentDidMount() {
  //   const currentPath = window.location.pathname;
  //   if (currentPath === '/gethelp') {
  //     this.menuEHRClick();
  //   }
  // }

  selectLanguage(middlewareApi, session) {
    let params = {};
    params.title = 'เลือกภาษา (Select Language)';
    params.buttons = [];
    params.buttons.push('ภาษาไทย');
    params.buttons.push('English');
    params.newMessage = this.handleNewUserMessage;
    params.greeting = this.greeting;
    params.middlewareApi = middlewareApi; //middlewareApi == lmabda_api
    params.session = session;
    renderCustomComponent(QuickReply, params, true);
  }

  greeting(Language, lambda_api, type) {
    var json = {
      session: session,
      queryInput: {
        text: {
          text: 'greeting',
          languageCode: 'en-US',
          typeofservice: type
        }
      }
    };
    if (lambda_api) {
      (async () => {
        await Axios.post(lambda_api, json).then((response) => {
          let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
            return item.platform === 'PLATFORM_UNSPECIFIED';
          });
          messages.forEach((msg) => {
            let fields = msg.payload.fields;
            if (fields.type.stringValue === 'text' && fields.Lang.stringValue === Language) {
              addResponseMessage(fields.messages.stringValue);
            }
          });
        });
      })();
    }
  }

  swapflag() {
    this.setState({
      sateshowflag: !this.sateshowflag
    });

  }

  blockUiEvent() {
    if (lastMessage) {
      setTimeout(() => {
        const sender = document.querySelector('.rcw-new-message');
        const button = document.querySelector('.rcw-send');
        if (blockingState) {
          if (!sender.hasAttribute('disabled') && !button.hasAttribute('disabled')) {
            sender.setAttribute('disabled', '');
            button.setAttribute('disabled', '');
            document.querySelector('.rcw-messages-container').style.backgroundColor = '#D4D7D9';
            document.querySelector('.rcw-sender').style.backgroundColor = '#D4D7D9';
            document.querySelector('.rcw-new-message').style.backgroundColor = '#D4D7D9';
            document.querySelector('.rcw-send').style.backgroundColor = '#D4D7D9';
          }
        }
      }, 200);
    }else if(closesender){
      //console.log("I'm here in closesender");
      setTimeout(() => {
        const sender = document.querySelector('.rcw-new-message');
        const button = document.querySelector('.rcw-send');
        //console.log("I'm here in closesender setTimeout");
        if (closesender) {
          //console.log("I'm here in blockingState setTimeout");
          if (!sender.hasAttribute('disabled') && !button.hasAttribute('disabled')) {
            sender.setAttribute('disabled', '');
            button.setAttribute('disabled', '');
            // document.querySelector('.rcw-messages-container').style.backgroundColor = '#D4D7D9';
            // document.querySelector('.rcw-sender').style.backgroundColor = '#D4D7D9';
            // document.querySelector('.rcw-new-message').style.backgroundColor = '#D4D7D9';
            // document.querySelector('.rcw-send').style.backgroundColor = '#D4D7D9';
          }
        }
      }, 200);
    } 
    else {
      setTimeout(() => {
        const addEventClick = document.querySelector('.rcw-launcher');
        if (!clickEventExist) {
          addEventClick.addEventListener('click', () => {
            clickEventExist = true;
            if (document.getElementsByClassName('rcw-hide-sm').length === 0 && blockingState) {
              setTimeout(() => {
                const sender = document.querySelector('.rcw-new-message');
                const button = document.querySelector('.rcw-send');
                if (!sender.hasAttribute('disabled') && !button.hasAttribute('disabled')) {
                  sender.setAttribute('disabled', '');
                  button.setAttribute('disabled', '');
                  document.querySelector('.rcw-messages-container').style.backgroundColor = '#D4D7D9';
                  document.querySelector('.rcw-sender').style.backgroundColor = '#D4D7D9';
                  document.querySelector('.rcw-new-message').style.backgroundColor = '#D4D7D9';
                  document.querySelector('.rcw-send').style.backgroundColor = '#D4D7D9';
                }
              }, 100);
            }
          });
        }
      }, 500);
    }
  }

  unblockUiEvent() {
    setTimeout(() => {
      const sender = document.querySelector('.rcw-new-message');
      const button = document.querySelector('.rcw-send');
      if (sender.hasAttribute('disabled') && button.hasAttribute('disabled')) {
        sender.removeAttribute('disabled');
        button.removeAttribute('disabled');
      }
      document.querySelector('.rcw-messages-container').style.backgroundColor = '';
      document.querySelector('.rcw-sender').style.backgroundColor = '';
      document.querySelector('.rcw-new-message').style.backgroundColor = '';
      document.querySelector('.rcw-send').style.backgroundColor = '';
    }, 100);
  }

  menuADClick() {
    this.setState({verifyADPass: false});
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    if (this.state.preventPaste) {
      this.disablePasteAndDrop(false)
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'AD' }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_AD;
    csharp_api = process.env.REACT_APP_CSHARP_API_AD;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "AD";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
    if (pasteEventNum === 0) {
      this.disablePasteAndDropEvent();
      pasteEventNum++;
    }
  }

  menuEHRClick() {
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'Unlock/Reset Account by IT One CS' }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_EHR;
    csharp_api = process.env.REACT_APP_CSHARP_API_EHR;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "EHR";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
  }

  menuSAPClick() {
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'SAP' }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_SAP;
    csharp_api = process.env.REACT_APP_CSHARP_API_SAP;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "SAP";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
  }

  menuS47Click() {
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'Get Help : Raise Incident' }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_SAP47;
    csharp_api = process.env.REACT_APP_CSHARP_API_S47;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "S47";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
  }

  menuSCGPClick() {
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'SANDEE : SCGP Coupa Supplier' }, false);
    //set environment
    // lambda_api = process.env.REACT_APP_LAMBDA_SCGP;
    // csharp_api = process.env.REACT_APP_CSHARP_API_SCGP;
    lambda_api = process.env.REACT_APP_LAMBDA_SCGP;
    csharp_api = process.env.REACT_APP_CSHARP_API_SCGP;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "SCGP";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
  }

  // menuGenAIClickTH() {
  //   this.setState({ clicked_th: true });
  //   this.setState({ clicked_eng: false });
  //   const dfMessenger = document.querySelector("df-messenger");
  //   const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
  //   if (dfMessenger) {
  //     dfMessenger.startNewSession({ retainHistory: false });
  //   }
  //   if (dfMessengerBubble) {
  //     dfMessengerBubble.openChat();
  //   }
  // }

  menuGenAIClick() {
    // this.setState({ clicked_eng: true });
    // this.setState({ clicked_th: false });
    this.setState({ toggleAI: true , toggleSAPChangeOwner: false});
    const dfMessenger = document.querySelector("df-messenger");
    const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
    if (dfMessengerBubble) {
      dfMessengerBubble.openChat();
    }
    if (dfMessenger) {
      dfMessenger.startNewSession({ retainHistory: false });
      if (!window.sessionStorage.getItem("dfcx_lang_code")) {
        // setTimeout(() => {
        //   dfMessenger
        //     .querySelector("df-messenger-chat-bubble")
        //     .shadowRoot.querySelector("df-messenger-chat")
        //     .shadowRoot.querySelector("df-messenger-user-input")
        //     .shadowRoot.querySelector(".textarea-wrapper textarea")
        //     .setAttribute("readonly", true);
        // }, 200);

        const start_selectLang = [
          {
            type: "html",
            html: "<b style='font-size:21px'>เลือกภาษา (Select Language)</b>",
          },
        ];
        dfMessenger.renderCustomCard(start_selectLang);
        const thai_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "ภาษาไทย",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(thai_btn);
        const eng_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "English",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(eng_btn);
      } else {
        window.addEventListener("df-request-sent", (event) => {
          event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
          // console.log(JSON.stringify(event.detail.data.requestBody));
        });
        dfMessenger.sendRequest("event", "greeting");
      }
    }
  }

  menuSAPChangeOwnerClick() {
    // this.setState({ clicked_eng: true });
    // this.setState({ clicked_th: false });
    this.setState({ toggleSAPChangeOwner: true , toggleAI: false});
    const dfMessenger = document.querySelector("df-messenger");
    const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
    if (dfMessengerBubble) {
      dfMessengerBubble.openChat();
    }
    if (dfMessenger) {
      dfMessenger.startNewSession({ retainHistory: false });
      if (!window.sessionStorage.getItem("dfcx_lang_code")) {
        // setTimeout(() => {
        //   dfMessenger
        //     .querySelector("df-messenger-chat-bubble")
        //     .shadowRoot.querySelector("df-messenger-chat")
        //     .shadowRoot.querySelector("df-messenger-user-input")
        //     .shadowRoot.querySelector(".textarea-wrapper textarea")
        //     .setAttribute("readonly", true);
        // }, 200);

        const start_selectLang = [
          {
            type: "html",
            html: "<b style='font-size:21px'>เลือกภาษา (Select Language)</b>",
          },
        ];
        dfMessenger.renderCustomCard(start_selectLang);
        const thai_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "ภาษาไทย",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(thai_btn);
        const eng_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "English",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(eng_btn);
      } else {
        window.addEventListener("df-request-sent", (event) => {
          event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
          // console.log(JSON.stringify(event.detail.data.requestBody));
        });
        dfMessenger.sendRequest("event", "greeting");
      }
    }
  }

  menuSCGARIBAClick() {
    if (blockingState || clearCloseTyping) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    clearCloseTyping = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: 'SANDEE : SAP Ariba Sourcing' }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_SCGARIBA;
    csharp_api = process.env.REACT_APP_CSHARP_API_SCGARIBA;
    const getLanguage = window.sessionStorage.getItem('_sandee_language');
    v_typeofservice = "SCGP";
    if (!getLanguage) {
      this.selectLanguage(lambda_api, session, csharp_api);
    } else {
      this.greeting(getLanguage, lambda_api, v_typeofservice);
    }
    var hasClass = document.getElementsByClassName('rcw-opened');
    if (hasClass.length === 0) {
      toggleWidget(); 
    }
    this.blockUiEvent();
  }

  checkIntentForBlockUI(msg) {
    switch (msg) {
      case 'Report Problem Completed':
        return true;
      case '8.2 SurveyCompleted':
        return true;
      case 'Survey':
        return true;
      case 'Case Opened':
        return true;
      case 'Default Fallback Intent':
        return true;
      case 'Report Requested Completed':
        return true;
      case 'Report Problem UnCompleted':
        return true;
      case '5.3 OTP Expired':
        return true;
      case 'Error':
        return true;

      default:
        return false;
    }
  }

  async handleNewUserMessage(newMessage) {
    closesender = true;
    //console.log("closesender : "+closesender);
    if (!window.sessionStorage.getItem('_sandee_language')) {
      window.sessionStorage.setItem('_sandee_language', 'TH');
    }
    const language = window.sessionStorage.getItem('_sandee_language');

    if (closesender && !this.state.verifyADPass) {
      this.blockUiEvent();
    }
    const ADPasswordPolicy = ({ message }) => {
      return <div class="rcw-message margin">
        <img src="/static/media/smile1.3b51dab9.png" class="rcw-avatar" alt="profile"></img>
        <div class="rcw-response">
          <div class="rcw-message-text" dangerouslySetInnerHTML={{ __html: message }} />
        </div>
      </div>
    }

    if (this.state.verifyADPass) {
      var message = validateADPassword(newMessage.trim(), language);
      if (message) {
        // addResponseMessage(message);
        renderCustomComponent(ADPasswordPolicy, { message: message })
        addResponseMessage(language === "ENG" ? "Please specify your password again." : "รบกวนระบุรหัสผ่านใหม่อีกครั้งค่ะ");
        return;
      }
      this.setState({ verifyADPass: false });
    }

    //request api controller
    json = {
      session: session,
      queryInput: {
        text: {
          text: newMessage,
          languageCode: 'en-US',
          typeofservice: v_typeofservice
        }
      }
    };
    let response = await Axios.post(lambda_api, json);
    //console.log(response);
    action = response.data.queryResult.action;
    if (
      action != null &&
      action != undefined &&
      action != '' &&
      newMessage != 'Greeting' &&
      action != 'input.unknown'
    ) {
      json_csharp = response.data;
      let response_csharp = await Axios.post(csharp_api, json_csharp);
      // console.log(response_csharp)

      if (response_csharp.data.jobject) {
        json = {
          session: session,
          queryInput: {
            event: response_csharp.data.jobject.followupEventInput
          }
        };
      } else {
        json = {
          session: session,
          queryInput: {
            event: response_csharp.data.data.followupEventInput
          }
        };
      }

      response = await Axios.post(lambda_api, json);
      // console.log(response);
      //blockingUI
      if (closesender) {
        this.unblockUiEvent();
      }
      if (this.checkIntentForBlockUI(response.data.queryResult.intent.displayName)) {
        blockingState = true;
        lastMessage = true;
        closesender = false;
        clearCloseTyping = true;
        this.blockUiEvent();
      }

      let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
        return item.platform === 'PLATFORM_UNSPECIFIED';
      });
      messages.forEach((msg) => {
        let fields = msg.payload.fields;
        if (fields.type.stringValue === 'quick_replies') {
          // this.selectChoice(msg);
          let params = {};
          // params.this  = self;
          params.title = fields.title.stringValue;
          params.newMessage = this.handleNewUserMessage;
          params.buttons = [];
          for (let item of fields.quick_replies.listValue.values) {
            params.buttons.push(item.stringValue);
          }
          closesender = true;
          clearCloseTyping = true;
          this.blockUiEvent();
          renderCustomComponent(QuickReply, params, true);
        } else if (fields.type.stringValue === 'text' && fields.Lang.stringValue === language) {
          addResponseMessage(fields.messages.stringValue);
          if (fields.hasOwnProperty('mode')) {
            if (fields.mode.stringValue === 'validate-pass') {
              this.setState({ verifyADPass: true });
            }
          }
          if (fields.hasOwnProperty('disablePaste')) {
            if (fields.disablePaste.stringValue === 'true') {
              if (!this.state.preventPaste) {
                this.disablePasteAndDrop(true);
                this.setState({ preventPaste: true });
              }
            } else {
              if (this.state.preventPaste) {
                this.disablePasteAndDrop(false);
                this.setState({preventPaste: false});
              }
            }
          }
        } else if (fields.type.stringValue === 'link') {
          addLinkSnippet({
            title: '',
            link: fields.messages.stringValue,
            target: '_blank'
          });
        }
      });
    } else {
      //BLockingUI
      if (closesender) {
        this.unblockUiEvent();
      }
      if (this.checkIntentForBlockUI(response.data.queryResult.intent.displayName)) {
        blockingState = true;
        lastMessage = true;
        closesender = false;
        clearCloseTyping = true;
        this.blockUiEvent();
      }

      let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
        return item.platform === 'PLATFORM_UNSPECIFIED';
      });
      messages.forEach((msg) => {
        let fields = msg.payload.fields;
        if (fields.type.stringValue === 'quick_replies') {
          // this.selectChoice(msg);
          let params = {};
          // params.this  = self;
          params.title = fields.title.stringValue;
          params.newMessage = this.handleNewUserMessage;
          params.buttons = [];
          for (let item of fields.quick_replies.listValue.values) {
            params.buttons.push(item.stringValue);
          }
          closesender = true;
          clearCloseTyping = true;
          this.blockUiEvent();
          renderCustomComponent(QuickReply, params, true);
        } else if (fields.type.stringValue === 'text' && fields.Lang.stringValue === language) {
          addResponseMessage(fields.messages.stringValue);
          if (fields.hasOwnProperty('mode')) {
            if (fields.mode.stringValue === 'validate-pass') {
              this.setState({ verifyADPass: true });
            }
          } 
          if (fields.hasOwnProperty('disablePaste')) {
            if (fields.disablePaste.stringValue === 'true') {
              if (!this.state.preventPaste) {
                this.disablePasteAndDrop(true);
                this.setState({preventPaste: true});
              }
            } else {
              if (this.state.preventPaste) {
                this.disablePasteAndDrop(false);
                this.setState({preventPaste: false});
              }
            }
          }
        } else if (fields.type.stringValue === 'link') {
          addLinkSnippet({
            title: '',
            link: fields.messages.stringValue,
            target: '_blank'
          });
        }
      });
    }
  }
  // blockCopyPass(num) {
  //   setTimeout(() => {
  //     var query_arr = document.querySelectorAll(".rcw-message");
  //     var txt = query_arr[query_arr.length - num].querySelector(".rcw-message-text");
  //     if(txt){
  //       txt.id = "sandee_pass_ad"
  //       txt.setAttribute("onselectstart", "return false");
  //       txt.setAttribute("onCopy", "return false");
  //       txt.setAttribute("ondragstart", "return false");
  //       // txt.setAttribute("onmousedown", "return false");
  //     }  
  //   }, 200);
  // }

  // blockCopyPassEvent() {
  //   setTimeout(() => {
  //     const addEventClick1 = document.querySelector('.rcw-launcher');
  //     if (addEventClick1) {
  //       addEventClick1.addEventListener('click', () => {
  //         console.log("t1");
  //         var query_arr = document.querySelectorAll("#sandee_pass_ad");
  //         if (query_arr && query_arr.length > 0) {
  //           console.log(query_arr)
  //           for (const i of query_arr) {
  //             i.setAttribute("onselectstart", "return false");
  //             i.setAttribute("onCopy", "return false");
  //             i.setAttribute("ondragstart", "return false");
  //           }
  //         }
  //       });
  //       blockPassEvent = true;
  //     }
  //   }, 500);
  // }

  disablePasteAndDrop(bool) {
    var query = document.querySelector('.rcw-new-message');
    if (bool) {
      if (query) {
        query.setAttribute("onpaste", "return false;");
        query.setAttribute("ondragover", "return false;");
        query.setAttribute("ondrop", "return false;");
      }
    } else {
      if (query) {
        query.removeAttribute("onpaste");
        query.removeAttribute("ondragover");
        query.removeAttribute("ondrop");
      }
    }
  }

  disablePasteAndDropEvent() {

    setTimeout(() => {
      const addEventClick1 = document.querySelector('.rcw-launcher');
      if (addEventClick1) {
        addEventClick1.addEventListener('click', () => {
          if (this.state.preventPaste) {
            setTimeout(() => {
              var query = document.querySelector('.rcw-new-message');
              if (query) {
                query.setAttribute("onpaste", "return false;");
                query.setAttribute("ondragover", "return false;");
                query.setAttribute("ondrop", "return false;");
              }
            }, 500);
          }
        });
      }
    }, 500);
  }

  // blockCopyPass(num) {
  //   setTimeout(() => {
  //     var query_arr = document.querySelectorAll(".rcw-message");
  //     var txt = query_arr[query_arr.length - num].querySelector(".rcw-message-text");
  //     if(txt){
  //       txt.id = "sandee_pass_ad"
  //       txt.setAttribute("onselectstart", "return false");
  //       txt.setAttribute("onCopy", "return false");
  //       txt.setAttribute("ondragstart", "return false");
  //       // txt.setAttribute("onmousedown", "return false");
  //     }  
  //   }, 200);
  // }

  // blockCopyPassEvent() {
  //   setTimeout(() => {
  //     const addEventClick1 = document.querySelector('.rcw-launcher');
  //     if (addEventClick1) {
  //       addEventClick1.addEventListener('click', () => {
  //         console.log("t1");
  //         var query_arr = document.querySelectorAll("#sandee_pass_ad");
  //         if (query_arr && query_arr.length > 0) {
  //           console.log(query_arr)
  //           for (const i of query_arr) {
  //             i.setAttribute("onselectstart", "return false");
  //             i.setAttribute("onCopy", "return false");
  //             i.setAttribute("ondragstart", "return false");
  //           }
  //         }
  //       });
  //       blockPassEvent = true;
  //     }
  //   }, 500);
  // }

  disablePasteAndDrop(bool) {
    var query = document.querySelector('.rcw-new-message');
    if (bool) {
      if (query) {
        query.setAttribute("onpaste", "return false;");
        query.setAttribute("ondragover", "return false;");
        query.setAttribute("ondrop", "return false;");
      }
    } else {
      if (query) {
        query.removeAttribute("onpaste");
        query.removeAttribute("ondragover");
        query.removeAttribute("ondrop");
      }
    }
  }

  disablePasteAndDropEvent() {
    setTimeout(() => {
      const addEventClick1 = document.querySelector('.rcw-launcher');
      if (addEventClick1) {
        addEventClick1.addEventListener('click', () => {
          if (this.state.preventPaste) {
            setTimeout(() => {
              var query = document.querySelector('.rcw-new-message');
              if (query) {
                query.setAttribute("onpaste", "return false;");
                query.setAttribute("ondragover", "return false;");
                query.setAttribute("ondrop", "return false;");
              }
            }, 500);
          }
        });
      }
    }, 500);
  }

  render() {
    return (
      <div className="sandee-container">
        <section>
          <div className="cardSamard">
            <Row className="rowSelectStyle"
              gutter={[{ xs: 8, sm: 8, md: 10, lg: 12, xl: 12, xxl: 24 }, 16]}
            >
              <Col span={6}>
                <CardImg src={teamwork_samard} className="Samard_TEAMWORK" />
              </Col>
              <Col span={12}>
                <CardTitle className="Samard_titleNameStyle">Samard-Fix Self Service
                  <div className="Samard_textStyle">
                    <p >แก้ปัญหาคอมพิวเตอร์ ด้วยตัวท่านเอง</p>
                  </div>

                  <div className='clickHere'>
                    <a href="https://sandee-samard.scg.com" rel="noopener noreferrer" target="_blank">
                      Click Here
                    </a>
                  </div>
                </CardTitle>
              </Col>
            </Row>
          </div>
        </section>

        <section>
          <div className="cardSelectChat">
            <CardTitle className="bannerSelectChat">SANDEE</CardTitle>
            <div className="contrainer-chat">
              <Row className='rowSelectStyle'>
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className='balloon'>
                    <CardImg className='imageSelectStyle' src={sandee_ai} />
                  </div>
                  <Button className='buttonSelectStyle talkwithsandeecolor' value="8" onClick={this.menuGenAIClick}>
                    {/* <p className="Chat_textStyle">ASK! SANDEE AI</p> */}
                    ASK! SANDEE AI 
                  </ Button>
                  {this.state.toggleAI && <AIChatbox />}
                </Col>
              </Row>
              {/* Enter Computer */}
              <Row className="rowSelectStyle">
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className="balloon">
                    <CardImg className="imageSelectStyle" src={laptop} />
                  </div>
                  <Button className="buttonSelectStyle" color="danger" value="1" onClick={this.menuADClick}>
                    {/* <p className="Chat_textStyle">Unlock/Reset : SCG AD/e-HR</p> */}
                    Unlock/Reset : SCG AD/e-HR
                  </Button>{' '}
                </Col>
              </Row>
              {/* SAP ECC6.0 */}
              <Row className="rowSelectStyle">
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className="balloon">
                    <CardImg className="imageSelectStyle" src={sap} />
                  </div>
                  <Button className="buttonSelectStyle" color="success" value="3" onClick={this.menuSAPClick}>
                    {/* <p className="Chat_textStyle">Unlock/Reset : SAP account</p> */}
                    Unlock/Reset : SAP account
                  </Button>{' '}
                </Col>
              </Row>
              {/* SAP Change Owner*/}
              <Row className="rowSelectStyle">
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className="balloon">
                    <CardImg className="imageSelectStyle" src={sap} />
                  </div>
                  <Button className="buttonSelectStyle sapChangeOwnerColor" value="5" onClick={this.menuSAPChangeOwnerClick}>
                    Change Owner : SAP account
                  </Button>
                  {this.state.toggleSAPChangeOwner && <SAPChangeOwnerChatbox />}
                </Col>
              </Row>
              {/* SAP R/3 4.7 */}
              <Row className="rowSelectStyle">
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className="balloon">
                    <CardImg className="imageSelectStyle" src={help} />
                  </div>
                  <Button className="buttonSelectStyle" color="warning" value="4" onClick={this.menuS47Click}>
                    {/* <p className="Chat_textStyle">Get Help : Raise Incident</p>{' '} */}
                    Get Help : Raise Incident
                  </Button>{' '}
                </Col>
              </Row>
              {/* SAP servicelevelone */}
              <Row className='rowSelectStyle'>
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className='balloon'>
                    <CardImg className='imageSelectStyle' src={service} />
                  </div>
                  <Button className='buttonSelectStyle' color="info" value="2" onClick={this.menuEHRClick}>
                    {/* <p className="Chat_textStyle">Unlock/Reset Account by IT One CS</p> */}
                    Unlock/Reset Account by IT One CS
                  </ Button>{' '}
                </Col>
              </Row>
              <Row className='rowSelectStyle'>
                <Col
                  md={{ span: 20 }}
                  lg={{ span: 16 }}
                  xl={{ span: 20 }}>
                  <div className='balloon'>
                    <CardImg className='imageSelectStyle' src={sap_Ariba} />
                  </div>
                  <Button className='buttonSelectStyle scgariba' value="7" onClick={this.menuSCGARIBAClick}>
                    {/* <p className="Chat_textStyle" >SCG SAP Ariba Sourcing</p> */}
                    SCG SAP Ariba Sourcing
                  </ Button>{' '}
                </Col>
              </Row>
            </div>
            <div className="SANDEE-User-Manual" >
              <Row>
                <Col>
                  <img className='img-book' src={guide_book}></img>
                  <a href="https://scg.service-now.com/myrequestscg?id=u_kb_article&sys_id=92ab3ba4db241450c48ef0eb0c9619b1" rel="noopener noreferrer" target="_blank">
                    วิธีการ Unlock & Reset
                  </a>
                </Col>
              </Row>
            </div>
            <Container>
              <img alt="" className="Sandee_OK" src={sandee_ok} />
            </Container>

            {
              //showflag == true?
              this.state.sateshowflag ? (
                <div>
                  <Widget
                    handleNewUserMessage={this.handleNewUserMessage}
                    profileAvatar={logo}
                    title="SANDEE Chatbot"
                    subtitle=""
                    menuADClick={this.menuADClick}
                    menuEHRClick={this.menuEHRClick}
                    menuSAPClick={this.menuSAPClick}
                    menuS47Click={this.menuS47Click}
                    menuSCGPClick={this.menuSCGPClick}
                    menuSCGARIBAClick={this.menuSCGARIBAClick}
                  />
                </div>
              ) : null
            }
          </div>
        </section>

      </div>
    );
  }
}
